import TicketLinkRenderer from "../cell_renderers/TicketLinkRenderer";
import { ValueGetterParams } from "ag-grid-community";

export const jiraTicketsColumnDefs = [
  {
    headerName: "Issue ID",
    field: "issue_key",
    flex: 1,
    filter: false,
    lockPosition: true,
    lockPinned: true,
    cellClass: ["text-left", "single-line"],
    cellRenderer: TicketLinkRenderer,
    cellStyle: { 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: '16px'
    }
  },
  {
    headerName: "Summary",
    field: "summary",
    toolTipField: "summary",
    flex: 3,
    filter: false,
    cellClass: ["text-left", "single-line"],
    valueGetter: (params: ValueGetterParams) => {
      return params.data.summary || "No summary available";
    },
    cellStyle: { 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: '16px'
    }
  },
  
  {
    headerName: "Status",
    field: "status",
    flex: 1,
    filter: false,
    cellClass: ["text-left", "single-line"],
    hide: false,
    cellStyle: { 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: '16px'
    }
  },
  {
    headerName: "Priority",
    field: "priority",
    flex: 1,
    filter: false,
    cellClass: ["text-left", "single-line"],
    cellClassRules: {
      "priority-low": (params: { value: string }) =>
        params.value.toLowerCase() === "low",
      "priority-medium": (params: { value: string }) =>
        params.value.toLowerCase() === "medium",
      "priority-high": (params: { value: string }) =>
        params.value.toLowerCase() === "high",
    },
    cellStyle: { 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: '16px'
    }
  }
]; 